import ReactGA from 'react-ga4';

const MEASUREMENT_ID = 'G-DW0NYXMQS1';

let isInitialized = false;

export const checkConsent = (): boolean => {
  const consent = localStorage.getItem('cookie-consent');
  return consent === 'accepted';
};

export const initGA = () => {
  if (!checkConsent() || isInitialized) {
    return;
  }

  try {
    ReactGA.initialize(MEASUREMENT_ID, {
      gaOptions: {
        siteSpeedSampleRate: 100,
      },
    });
    isInitialized = true;
  } catch (error) {
    console.error('Failed to initialize Google Analytics:', error);
  }
};

export const logPageView = (path: string, title?: string) => {
  if (!checkConsent() || !isInitialized) {
    return;
  }

  try {
    ReactGA.send({
      hitType: 'pageview',
      page: path,
      title: title || document.title
    });
  } catch (error) {
    console.error('Failed to log page view:', error);
  }
};

export const logEvent = (category: string, action: string, label?: string, value?: number) => {
  if (!checkConsent() || !isInitialized) {
    return;
  }

  try {
    ReactGA.event({
      category,
      action,
      label,
      value,
    });
  } catch (error) {
    console.error('Failed to log event:', error);
  }
};

export const logCustomEvent = (eventName: string, params?: Record<string, any>) => {
  if (!checkConsent() || !isInitialized) {
    return;
  }

  try {
    ReactGA.event(eventName, params);
  } catch (error) {
    console.error('Failed to log custom event:', error);
  }
};

export const trackButtonClick = (buttonName: string, location: string, category: string = 'button_click') => {
  logEvent(category, 'click', `${buttonName} - ${location}`);
};
